import React from 'react';
import PropTypes from 'prop-types';
import {PageWrapper} from '../components/PageWrapper';
import {usePage} from '../contexts/PageContext';
import {useCMS} from 'tinacms';
import {InlineBlocks, InlineForm} from 'react-tinacms-inline';
import {useCMSBuilder} from '../contexts/CMSBuilderContext';
import {VerticalBlock} from '../components/Block/SimpleBlock';
import {HorizontalBlock} from '../components/Block/DobleBlock';

/**
 * Page componente used to start editing and creating all the componentes
 * @author Yadian
 * @since v0.0.1
 * */
const Page = ({children}) => {
  const {viewport} = usePage();
  const {_enabled} = useCMS();
  const {form} = useCMSBuilder();
  return (
    <PageWrapper viewport={viewport} editing={_enabled}>
      {children}
      <div className='dfl-page-wrapper'>
        {form && <InlineForm form={form}
        >
          <InlineBlocks name='blocks' blocks={BLOCKS}/>
        </InlineForm>
        }
      </div>
    </PageWrapper>
  );
};

const BLOCKS = {
  vertical: VerticalBlock,
  horizontal: HorizontalBlock,
  // features: featureListBlock,
  // title: titleBlock,
  // imageBlock: imageBlock,
  // imageAndContent: imageAndContentBlock,
};

export default Page;

Page.propTypes = {
  children: PropTypes.any
};
